import { Text } from "@contentful/rich-text-types";
import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import {
  IContentSection,
  IMainHeading,
  IPageFields,
  IText,
} from "../../@types/generated/contentful";
import { getIdFromString } from "../../utils/helperFunctions";
import CustomContainer from "../container";

export interface TableOfContentsEntry {
  title: string;
  level: "H1" | "H2" | "H3" | "H4" | "H5" | "H6";
  id: string;
}

const TableOfContents = (props: {
  tableOfContents: TableOfContentsEntry[];
}) => {
  const { tableOfContents } = props;

  let counter = 0;

  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: "792px",
        width: "100%",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        py: { xs: 5, sm: 10 },
        " span": { mb: 0 },
      }}
    >
      {tableOfContents.map((entry, i) => {
        const { title, id, level } = entry;
        if (level == "H2") {
          counter++;
        }
        return (
          <Box
            key={"toCEntry" + i}
            sx={{ display: "flex", gap: 3, justifyContent: "flex-start" }}
          >
            {counter !== 0 && (
              <Typography
                variant="body1"
                sx={{ color: theme.palette.primary.main, fontSize: "20px" }}
              >
                {level == "H2" ? counter + "." : ""}{" "}
              </Typography>
            )}
            <Typography
              variant="body1"
              key={"toCEntry" + i}
              sx={{
                fontSize: "20px",
                pl: Math.max(0, parseInt(level.charAt(1)) - 3) * 4,
              }}
            >
              <a href={"#" + id} style={{ color: theme.palette.primary.main }}>
                {title}
              </a>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default TableOfContents;

/**
 *
 * Currently only captures all H3 elements within a page, since it's only used for pages with pageType 'Fleckxikon'
 */
export const getTableOfContentsFromPage = (page: IPageFields) => {
  let tableOfContents = [] as TableOfContentsEntry[];

  // // Title from Hero
  // if (
  //   page.heroTeaser &&
  //   page.heroTeaser.sys.contentType.sys.id == "heroArticle"
  // ) {
  //   const heroArticle = page.heroTeaser as IHeroArticle;
  //   tableOfContents.push({
  //     title: heroArticle.fields.headline,
  //     level: "H1",
  //     id: getIdFromString(heroArticle.fields.headline),
  //   });
  // }
  page.contentSections?.forEach((cs) => {
    if (cs.sys.contentType.sys.id == "contentSection") {
      let contentSection = cs as IContentSection;
      // // Title of content section
      //   let contentSectionTitle = contentSection.fields.heading;
      //   if (contentSectionTitle) {
      //     let level = contentSection.fields.level || "H2";
      //     tableOfContents.push({
      //       title: contentSectionTitle,
      //       level,
      //       id: getIdFromString(contentSection.fields.internal),
      //     });
      //   }
      contentSection.fields.sectionItems?.forEach((item) => {
        // // Title of mainHeading section element
        // if (item.sys.contentType.sys.id == "mainHeading") {
        //   const mainHeading = item as IMainHeading;
        //   const { heading, level, internal } = mainHeading.fields;
        //   tableOfContents.push({
        //     title: heading,
        //     level,
        //     id: getIdFromString(internal),
        //   });
        // }
        if (item.sys.contentType.sys.id == "text") {
          const textSection = item as IText;

          textSection.fields.content.content.forEach((content) => {
            // // H4 within text field
            // if (content.nodeType == "heading-4") {
            //   let title = (content.content[0] as Text).value;
            //   const level = "H4";
            //   tableOfContents.push({
            //     title,
            //     level,
            //     id: getIdFromString(title),
            //   });
            // }

            // // H3 within text field
            if (content.nodeType == "heading-3") {
              let title = (content.content as Text[])
                .map((textContent: Text) => textContent.value)
                .join(" ");

              const level = "H3";
              tableOfContents.push({
                title,
                level,
                id: getIdFromString(title),
              });
            }

            // // H2 within text field
            // if (content.nodeType == "heading-2") {
            //   let title = (content.content[0] as Text).value;
            //   const level = "H2";
            //   tableOfContents.push({
            //     title,
            //     level,
            //     id: getIdFromString(title),
            //   });
            // }

            // // H1 within text field
            // if (content.nodeType == "heading-1") {
            //   let title = (content.content[0] as Text).value;
            //   const level = "H1";
            //   tableOfContents.push({
            //     title,
            //     level,
            //     id: getIdFromString(title),
            //   });
            // }
          });
        }
      });
    }
  });
  return tableOfContents;
};
